import script from "./TaskList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskList.vue?vue&type=script&setup=true&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=785c7937&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785c7937"]])

export default __exports__